import { call, put, takeLatest } from 'redux-saga/effects';

import { CompanyUser } from '@models/User';
import { UserApi } from '@apis/UserApi';

import {
  companyUsersFetch,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleCompanyUsersFetch() {
  const state: StateUpdatePayload = { companyUsers: [] };
  try {
    state.companyUsers = (yield call(UserApi.getAllCompanyUsers)) as CompanyUser[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(companyUsersFetch, handleCompanyUsersFetch);
}
